import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type TagTone = 'neutral' | 'accent' | 'muted';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: TagTone;
  leftIcon?: ReactNode;
}

const toneClasses: Record<TagTone, string> = {
  neutral: 'bg-stone-800 text-stone-300 border border-stone-800/80',
  accent: 'bg-amber-950/30 text-amber-400 border border-amber-900/40',
  muted: 'bg-stone-900 text-stone-500 border border-stone-800/60',
};

export function Tag({ tone = 'neutral', leftIcon, className, children, ...rest }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.2em]',
        toneClasses[tone],
        className,
      )}
      {...rest}
    >
      {leftIcon ? <span className="inline-flex shrink-0">{leftIcon}</span> : null}
      {children}
    </span>
  );
}
